module.exports = __webpack_public_path__ + "img/edge_step_5.e674bc6a.png";